import { render, staticRenderFns } from "./VerifyLinkExpired.vue?vue&type=template&id=5d935f16"
import script from "./VerifyLinkExpired.vue?vue&type=script&lang=js"
export * from "./VerifyLinkExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports